module.exports = __webpack_public_path__ + "static/media/1200px-The_Economist_Logo.svg.d48720c3.png";